import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class PageService {
  subjects = new Map<string, BehaviorSubject<any>>()

  constructor() {
    // do nothing
  }

  clear(): void {
    this.subjects.clear()
  }

  updateSubject(key: string, value: any): void {
    if (this.subjects.has(key)) {
      const subject = this.subjects.get(key)
      subject?.next(value)
    } else {
      this.subjects.set(key, new BehaviorSubject<any>(value))
    }
  }

  getSubject(key: string): BehaviorSubject<any> | undefined {
    if (!this.subjects.has(key)) {
      this.subjects.set(key, new BehaviorSubject<any>(undefined))
    }
    return this.subjects.get(key)
  }
}
